var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useState } from 'react';
import styled, { useTheme } from 'styled-components';
import Typography from '../../Styles/Typography/Typography';
import Spinner from '../../Progress/Spinner/Spinner';
import Skeleton from '../../Progress/Skeleton/Skeleton';
import DropDown from '../../NavigationElements/DropDown/DropDown';
import Icon from '../../Styles/Icons/Icon';
import DoneImage from '../../img/button/done_icon.svg';
import ErrorImage from '../../img/button/error_icon.svg';
import { ButtonStyle, ActionResultContainer } from '../buttonsCommonStyles';
const ActionAndButtonContainer = styled.div `
  display: ${props => props.hideIf ? 'none' : props.isBlock ? 'flex' : 'inline-flex'};
  width: ${props => (props.isBlock ? '100%' : 'fit-content')};
  flex-direction: column;
`;
const ButtonBox = styled.div `
  box-sizing: border-box;
  line-height: ${props => props.theme.fonts.lineHeight};
`;
const ButtonDropBox = styled.div `
  box-sizing: border-box;
  margin: ${props => (props.margin ? props.margin : props.theme.paddingsMargins.themeMenuMargin)};
  display: flex;
  flex-direction: row;
  align-items: stretch;
  justify-content: center;
`;
const ButtonContainer = styled(ButtonStyle) `
  margin: 0rem 0rem 0rem 0rem;
  padding: 0rem 0rem 0rem 0rem;
  padding-left: ${props => props.theme.paddingsMargins.themePaddingSingle};
  padding-right: ${props => props.theme.paddingsMargins.themePaddingSingle};
  border-top-right-radius: 0px;
  border-bottom-right-radius: 0px;
  &:hover {
    box-shadow: ${props => props.theme.boxes.boxShadow};
    transform: translateY(0px);
  }
  &:active {
    box-shadow: none;
    transform: translateY(0px);
   }
`;
const DropDownContainer = styled(ButtonStyle) `
  margin: 0rem 0rem 0rem 0rem;
  display: flex;
  align-items: stretch;
  justify-content: center;
  margin-left: 2px;
  border-top-left-radius: 0px;
  border-bottom-left-radius: 0px;
  box-shadow: ${props => props.openDropDown ? 'none' : props.theme.boxes.boxShadow};
  &:hover {
    box-shadow: none;
    transform: translateY(0px);
  }
`;
const ButtonDrop = (_a) => {
    var { color = 'main', text = 'Button', errorText = 'Error', doneText = 'Done', dropdownPlacement = 'bottom', onlyClick = false, language, onClick, isError = false, isLoadingSpinner = false, isLoading = false, isDone = false, isDisabled = false, secondary = false, noBorder = false, isFull = false, isBlock = false, noMargin = false, margin, icon = 'menu', size = 'button', hideIf = false, isMenuOpen = () => { }, children } = _a, props = __rest(_a, ["color", "text", "errorText", "doneText", "dropdownPlacement", "onlyClick", "language", "onClick", "isError", "isLoadingSpinner", "isLoading", "isDone", "isDisabled", "secondary", "noBorder", "isFull", "isBlock", "noMargin", "margin", "icon", "size", "hideIf", "isMenuOpen", "children"]);
    const [openDropDown, setOpenDropDown] = useState(false);
    const theme = useTheme();
    const menuIsShown = (value) => setOpenDropDown(value);
    return isLoadingSpinner
        ? secondary ? _jsx(Spinner, { secondary: true }) : _jsx(Spinner, {})
        : isLoading
            ? _jsx(Skeleton, { height: '35px', width: isBlock ? '100%' : `${150}px`, margin: noMargin ? '0px' : theme.paddingsMargins.themeMenuMargin, style: {
                    padding: theme.paddingsMargins.minPadding,
                    paddingLeft: theme.paddingsMargins.themeMenuPaddingSingle,
                    paddingRight: theme.paddingsMargins.themeMenuPaddingSingle
                } })
            : _jsxs(ActionAndButtonContainer, Object.assign({ hideIf: hideIf, isBlock: isBlock }, props, { children: [_jsx(ButtonBox, { children: _jsxs(ButtonDropBox, Object.assign({ margin: margin }, { children: [_jsx(ButtonContainer, Object.assign({ isDisabled: isDisabled, onClick: isDisabled ? () => { } : onClick, noBorder: noBorder, secondary: secondary, isFull: isFull, isBlock: isBlock, noMargin: noMargin, color: color }, { children: _jsx(Typography, Object.assign({ color: color, size: size, style: { whiteSpace: 'nowrap' } }, { children: text })) })), _jsx(DropDown, Object.assign({ onlyClick: onlyClick, placement: dropdownPlacement, isMenuOpen: (data) => { isMenuOpen(data); menuIsShown(data); }, component: _jsx(DropDownContainer, Object.assign({ isDisabled: isDisabled, noBorder: noBorder, secondary: secondary, isFull: isFull, isBlock: isBlock, noMargin: noMargin, openDropDown: openDropDown, color: color }, { children: _jsx(Icon, { color: color, noMargin: true, icon: icon, style: { padding: '0.1rem' } }) })) }, { children: children }))] })) }), (isError || isDone) &&
                        _jsxs(ActionResultContainer, Object.assign({ noMargin: noMargin }, { children: [_jsx("img", { style: { height: 'auto', width: '15px' }, src: isError ? ErrorImage : DoneImage, alt: isError ? 'error' : 'done' }), _jsx(Typography, Object.assign({ color: isError ? 'error' : 'done', size: "note" }, { children: isError ? errorText : doneText }))] }))] }));
};
export default ButtonDrop;
